import type { SVGProps } from 'react';

const SvgCompanyTiktok = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M6 3C4.355 3 3 4.355 3 6v12c0 1.645 1.355 3 3 3h12c1.645 0 3-1.355 3-3V6c0-1.645-1.355-3-3-3zm0 2h12c.565 0 1 .435 1 1v12c0 .565-.435 1-1 1H6c-.565 0-1-.435-1-1V6c0-.565.435-1 1-1m6 2v7c0 .565-.435 1-1 1s-1-.435-1-1 .435-1 1-1v-2c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3v-3.768c.616.44 1.26.768 2 .768V9c-.047 0-.737-.22-1.219-.639C14.3 7.941 14 7.415 14 7z"
    />
    <path
      fill="currentcolor"
      d="M2.95 18V6A3.065 3.065 0 0 1 6 2.95V3C4.355 3 3 4.355 3 6v12c0 1.645 1.355 3 3 3h12c1.645 0 3-1.355 3-3V6c0-1.645-1.355-3-3-3v-.05A3.065 3.065 0 0 1 21.05 6v12A3.065 3.065 0 0 1 18 21.05H6A3.065 3.065 0 0 1 2.95 18m15.05.95V19H6v-.05zm.95-.95V6a.934.934 0 0 0-.95-.95H6a.934.934 0 0 0-.95.95v12c0 .537.413.95.95.95V19c-.565 0-1-.435-1-1V6c0-.565.435-1 1-1h12c.565 0 1 .435 1 1v12c0 .565-.435 1-1 1v-.05c.537 0 .95-.413.95-.95M10 14c0-.565.435-1 1-1v-2c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3v-3.768c.616.44 1.26.768 2 .768V9c-.047 0-.737-.22-1.219-.639C14.3 7.941 14 7.415 14 7h-2v7c0 .565-.435 1-1 1v-.05c.537 0 .95-.413.95-.95V6.95h2.1V7c0 .394.288.908.764 1.323.236.206.524.363.76.469a4 4 0 0 0 .393.15l.027.006q.012.002.006.002h.05v2.1H16c-.725 0-1.354-.31-1.95-.723V14A3.065 3.065 0 0 1 11 17.05 3.065 3.065 0 0 1 7.95 14 3.065 3.065 0 0 1 11 10.95h.05v2.1H11a.935.935 0 0 0-.95.95c0 .537.413.95.95.95V15c-.565 0-1-.435-1-1m8-11.05V3H6v-.05z"
    />
  </svg>
);
export default SvgCompanyTiktok;
